var path = 'app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/targetTracking/targetTrackingSummary.html';
var html = "<target-tracking-summary policy=\"$ctrl.policy\"\n                         server-group=\"$ctrl.serverGroup\"\n                         application=\"$ctrl.application\"></target-tracking-summary>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/targetTracking/targetTrackingSummary.html
// module id = 1178
// module chunks = 0